var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0808105,
    width: 32,
    height: 32,
    rx: 5,
    fill: "#00A63E",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.602 18.8728L10.0808 22L13.2081 21.4788C13.7511 21.3883 14.2523 21.1304 14.6416 20.7411L21.694 13.6886C22.2097 13.1728 22.2097 12.3366 21.6939 11.8208L20.2599 10.3868C19.7441 9.87105 18.9079 9.87106 18.3921 10.3868L11.3398 17.4393C10.9505 17.8286 10.6925 18.3298 10.602 18.8728Z",
    stroke: "#00A63E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4141 12L20.0808 14.6667",
    stroke: "#00A63E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a0bfa86348490fb33736886faa2c69b1.svg";
export { ForwardRef as ReactComponent };